var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTickSelect = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "url(#paint0_linear_926_105)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 14.1177L16.9167 8L18 8.94118L9.875 16L5 11.7647L6.08334 10.8236L9.875 14.1177Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_926_105",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E602D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860BB5"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTickSelect);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tick-select.51297edcd97f14c3f5d2a9a8146e4b67.svg";